import { VehiculeCheckProgressStatus } from '@/api/entities/vehicule-check';
import {
  InspectionProgressStatusUpdatePayload,
  InspectionVideoUploadProgress,
  useSocket,
} from '../socket.hooks';
import { useEffect, useMemo, useState } from 'react';
import { useGetVehiculeCheckById } from '../vehicule-check.hooks';

type VehiculeCheckVideoSocketsProps = {
  vehiculeCheckId: string;
};

export const useVehiculeCheckVideoSockets = ({
  vehiculeCheckId,
}: VehiculeCheckVideoSocketsProps) => {
  const [vehiculeCheckProgressStatus, setVehiculeCheckProgressStatus] =
    useState<VehiculeCheckProgressStatus>(
      VehiculeCheckProgressStatus.IN_PROGRESS
    );

  const [videoUploadProgressPercent, setVideoUploadProgressPercent] =
    useState<number>(0);

  const { data: vehiculeCheck } = useGetVehiculeCheckById(vehiculeCheckId);

  const isVideoUploading = useMemo(() => {
    return (
      vehiculeCheckProgressStatus ===
        VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_VIDEO ||
      vehiculeCheckProgressStatus ===
        VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_CHUNKS
    );
  }, [vehiculeCheckProgressStatus]);

  const isVideoProgressCompleted = useMemo(() => {
    return (
      vehiculeCheckProgressStatus === VehiculeCheckProgressStatus.COMPLETED ||
      vehiculeCheckProgressStatus ===
        VehiculeCheckProgressStatus.COMPLETED_REPORT_AVAILABLE
    );
  }, [vehiculeCheckProgressStatus]);

  useSocket({
    onInspectionProgressStatusUpdate: (
      data: InspectionProgressStatusUpdatePayload
    ) => {
      if (vehiculeCheckId === data?.vehiculeCheckId) {
        setVehiculeCheckProgressStatus(
          data?.progressStatus as VehiculeCheckProgressStatus
        );
        console.warn('inspectionProgressStatusUpdate', data);
      }
    },
  });

  useSocket({
    onInspectionVideoUploadProgress: (data: InspectionVideoUploadProgress) => {
      if (vehiculeCheckId === data?.vehiculeCheckId) {
        setVideoUploadProgressPercent(data?.progress);
        console.warn('inspectionVideoUploadProgress', data);
      }
    },
  });

  useEffect(() => {
    if (vehiculeCheck?.data?.progressStatus) {
      setVehiculeCheckProgressStatus(
        vehiculeCheck?.data?.progressStatus as VehiculeCheckProgressStatus
      );
    }
  }, [vehiculeCheck]);

  return {
    vehiculeCheckProgressStatus,
    videoUploadProgressPercent,
    isVideoUploading,
    isVideoProgressCompleted,
  };
};
